import { Box, Divider, Stack, Typography } from "@mui/material";

const PVSignatures = ({ signatures }) => {
  return (
    <Stack direction="row" justifyContent="space-between" spacing={4}>
      {signatures &&
        !!signatures.length &&
        signatures.map((signature) => (
          <Box textAlign="center" width="100%" sx={{ p: 4 }} key={signature.id}>
            <Typography variant="subtitle2" mb={8}>
              {signature.fullname}
            </Typography>
            <Divider sx={{ m: 2 }} />
          </Box>
        ))}
      {!(signatures && signatures.length) && (
        <>
          <Box textAlign="center" width="100%" sx={{ p: 4 }}>
            <Typography variant="subtitle2" mb={8}>
              Nicolas Celier
            </Typography>
            <Divider sx={{ m: 2 }} />
          </Box>
          <Box textAlign="center" width="100%" sx={{ p: 4 }}>
            <Typography variant="subtitle2" mb={8}>
              Geoffroy Bragadir
            </Typography>
            <Divider sx={{ m: 2 }} />
          </Box>
        </>
      )}
    </Stack>
  );
};

export default PVSignatures;
